import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Modal } from '@startuptools/ui/Modal';
import { ModalDialog } from '@startuptools/ui/ModalDialog';
import { ModalClose } from '@startuptools/ui/ModalClose';
import DialogContent from '@mui/joy/DialogContent';
import { List } from '@startuptools/ui/List';
import { ListItem } from '@startuptools/ui/ListItem';
import { useMeetingSelectDialogSuspenseQuery } from './MeetingSelectDialog.graphql';
import { GqlMeetingKind } from '../../../graphql/base-types.graphql';
import { ListItemContent } from '@startuptools/ui/ListItemContent';
import { ListItemButton } from '@startuptools/ui/ListItemButton';
import { ListDivider } from '@startuptools/ui/ListDivider';
import { Fragment } from 'react/jsx-runtime';
import { Meeting } from './Meeting';

export const MeetingSelectDialog = ({
  onClose,
  onSelected,
  allowMeetingKinds,
}: {
  onClose: () => void;
  onSelected: (meetingId: string) => Promise<unknown>;
  allowMeetingKinds: GqlMeetingKind[];
}) => {
  const companyId = useCompanyId();

  const {
    data: {
      meetings: { models: meetings },
    },
  } = useMeetingSelectDialogSuspenseQuery({
    variables: { companyId, kinds: allowMeetingKinds },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <Modal open onClose={onClose}>
      <ModalDialog>
        <ModalClose />

        <DialogContent sx={{ mt: 2 }}>
          <List sx={{ '--List-gap': '2px' }}>
            {meetings.map(m => (
              <Fragment key={m.id}>
                <ListItem key={m.id}>
                  <ListItemButton onClick={() => onSelected(m.id).then(() => onClose())}>
                    <ListItemContent>
                      <Meeting meeting={m} />
                    </ListItemContent>
                  </ListItemButton>
                </ListItem>
                <ListDivider />
              </Fragment>
            ))}
          </List>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};
